import * as Safe from "safe-portals";

// API definitions that something that provides Campaign data to flow needs
// to conform to.
// Because campaigns are a core flow concept (not like Campaign Targets which are a plugin concept)
// we are not versioning the config, nor making it generic.
// We know what the config needs to be, and it will be easy to migrate to a new version of the config.
export interface CampaignProviderDef {
  /** Prefix with provider plugin_name: */
  provider_unique_id: string;
  label: string;
}

// Can't use the serializer here because it causes a circular loop
export const CampaignProviderConfigSerializer = Safe.obj({
  provider_unique_id: Safe.str,
  config: Safe.array(
    Safe.obj({
      name: Safe.str,
      id: Safe.str,
    })
  ),
});

/**
 * The configuration required to identify and make use of a pluggable 'CampaignProvider'
 * This is a mechanism to allow different ways of associating external campaigns with a journey.
 * As an example of an external campaign, this could be a campaign that exists within Identiy.
 * See CampaignPicker
 */
export type CampaignProviderConfig = Safe.TypeIn<typeof CampaignProviderConfigSerializer>;

export function makeCampaignProviderDef(def: CampaignProviderDef) {
  return def;
}
